import { VALUES_PER_PAGE } from '../../components/pagination/constants';
import { ORDER_BY } from '../../components/table/constants';

const COLUMNS_LIST = {
  USER_NAME: {
    value: 'commentList',
    label: 'general.sort.by_date',
    sortName: 'comment',
    defaultOrderBy: ORDER_BY.DESC,
    order: 1
  },
  FIRST_ACCESS: { value: '', label: '', order: 2 }
};

const COMMENT_STATUS_ENUM = {
  APPROVED: 1,
  SPAM_CONFIRMED: 5,
  DISAPPROVED: 6
};

const NOTIFICATION_STATUS = {
  nonRevised: 'AWAITING_MODERATION',
  approved: 'APPROVED',
  reproved: 'DISAPPROVED',
  markedAsSpamByOwner: 'SPAM_CONFIRMED',
  all: 'ALL',
  markedAsSpamByUser: 'SPAM',
  editing: 'EDITING'
};

const TABS_INDEXES = {
  nonRevised: 0,
  approved: 1,
  reproved: 2,
  markedAsSpamByOwner: 3,
  all: 4,
  configurations: 5
};

const INDEXES_TABS = {
  0: 'nonRevised',
  1: 'approved',
  2: 'reproved',
  3: 'markedAsSpamByOwner',
  4: 'all',
  5: 'configurations'
};

const COMMENT_COLUMN_SORT = COLUMNS_LIST.USER_NAME.sortName;

const INITIAL_STATE = {
  activedTab: TABS_INDEXES.nonRevised,
  comments: [],
  content: [],
  loadingUsers: false,
  membershipClass: null,
  optionsSnapshot: {
    instantTopicApproval: false,
    instantReplyApproval: false,
    commentForAllClasses: false,
    active: false,
    personaConfiguration: {
      enabled: false,
      persona: {
        avatarFileKey: null,
        name: null
      }
    }
  },
  page: 0,
  selectAll: false,
  size: VALUES_PER_PAGE.TEN,
  sortOptions: {
    [COMMENT_COLUMN_SORT]: ORDER_BY.DESC
  },
  status: NOTIFICATION_STATUS.nonRevised,
  totalElements: 0,
  user: null,
  usersData: {},
  pageId: [],
  moduleId: [],
  pagesAndModules: []
};

const DEFAULT_PAGE_SIZE = 5;

const PERSONA_NAME_MAX_LENGTH = 50;

export {
  COLUMNS_LIST,
  COMMENT_STATUS_ENUM,
  INDEXES_TABS,
  INITIAL_STATE,
  NOTIFICATION_STATUS,
  TABS_INDEXES,
  DEFAULT_PAGE_SIZE,
  PERSONA_NAME_MAX_LENGTH
};
